var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLunaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_775_1306)",
    fillOpacity: 0.2,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8458 21.9368C27.689 21.6666 27.2478 21.2464 26.1499 21.4465C25.5421 21.5566 24.9245 21.6066 24.3069 21.5766C22.0227 21.4765 19.9542 20.406 18.5131 18.7551C17.2387 17.3043 16.4544 15.4133 16.4446 13.3722C16.4446 12.2316 16.6603 11.131 17.1015 10.0905C17.5328 9.07996 17.2289 8.54968 17.0132 8.32956C16.7878 8.09944 16.2584 7.77927 15.2192 8.2195C11.2097 9.94041 8.72947 14.0426 9.02357 18.4349C9.31767 22.5671 12.1606 26.099 15.9251 27.4297C16.827 27.7499 17.7779 27.94 18.7582 27.98C18.9151 27.99 19.0719 28 19.2288 28C22.5129 28 25.5911 26.4192 27.5321 23.7277C28.189 22.7972 28.0125 22.2069 27.8458 21.9368Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_775_1306",
    x1: 18.5,
    y1: 0,
    x2: 18.5,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB520"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunaLight);
export default __webpack_public_path__ + "static/media/luna-light.227e41cce0c22177d95f289477ee1828.svg";
export { ForwardRef as ReactComponent };